import React, { useEffect, useState } from "react";

function GetContact() {
  const [contacts, setContacts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [page, setPage] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const limit = 30;

  useEffect(() => {
    fetch("https://visitguru.in/api/v1/contact/getContact")
      .then((response) => response.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          // Sort contacts by createdAt descending (latest first)
          const sortedContacts = data.data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setContacts(sortedContacts);
          setFilteredContacts(sortedContacts);
        }
      })
      .catch((error) => console.error("Error fetching contacts:", error));
  }, []);

  // Filter contacts by date range
  useEffect(() => {
    let result = contacts;

    if (fromDate || toDate) {
      result = contacts.filter((contact) => {
        if (!contact.createdAt) return true;
        const contactDate = new Date(contact.createdAt);
        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;
        
        if (from && to) {
          to.setHours(23, 59, 59, 999);
          return contactDate >= from && contactDate <= to;
        }
        if (from) return contactDate >= from;
        if (to) {
          to.setHours(23, 59, 59, 999);
          return contactDate <= to;
        }
        return true;
      });
    }

    setFilteredContacts(result);
    setPage(1);
  }, [contacts, fromDate, toDate]);

  const totalPages = Math.ceil(filteredContacts.length / limit);
  const currentContacts = filteredContacts.slice((page - 1) * limit, page * limit);

  const handlePrev = () => setPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () => setPage((prev) => Math.min(prev + 1, totalPages));

  return (
    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
      <div className="rounded-t mb-0 px-4 py-3 border-0 flex items-center justify-between">
        <h3 className="font-semibold text-base text-blueGray-700">
          Contact{" "}
          <span className="ml-2 text-sm text-blueGray">
            (Total Contacts: {filteredContacts.length})
          </span>
        </h3>
        
        <div className="flex gap-4 mt-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              From Date
            </label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="w-40 border rounded-md px-2 py-1 text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              To Date
            </label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="w-40 border rounded-md px-2 py-1 text-sm"
            />
          </div>
        </div>
      </div>

      <div className="block w-full overflow-x-auto">
        <table className="items-center w-full bg-transparent border-collapse">
          <thead>
            <tr>
              {["#", "Full Name", "Email", "Mobile", "Description", "Date"].map(
                (head, i) => (
                  <th
                    key={i}
                    className="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
                  >
                    {head}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {currentContacts.length > 0 ? (
              currentContacts.map((contact, index) => (
                <tr key={contact._id}>
                  <td className="border-t-0 px-6 align-middle text-xs whitespace-nowrap p-4 text-left">
                    {(page - 1) * limit + index + 1}
                  </td>
                  <td className="border-t-0 px-6 align-middle text-xs whitespace-nowrap p-4">
                    {contact.fullName || "N/A"}
                  </td>
                  <td className="border-t-0 px-6 align-middle text-xs whitespace-nowrap p-4">
                    {contact.email || "N/A"}
                  </td>
                  <td className="border-t-0 px-6 align-middle text-xs whitespace-nowrap p-4">
                    {contact.mobile || "N/A"}
                  </td>
                  <td className="border-t-0 px-6 align-top text-xs p-4" style={{maxWidth: '200px', wordWrap: 'break-word'}}>
                    {contact.description ? 
                      contact.description.split(' ').reduce((acc, word, index) => {
                        if (index > 0 && index % 15 === 0) {
                          return acc + '\n' + word;
                        }
                        return acc + (index > 0 ? ' ' : '') + word;
                      }, '').split('\n').map((line, i) => (
                        <div key={i}>{line}</div>
                      ))
                      : "N/A"}
                  </td>
                  <td className="border-t-0 px-6 align-middle text-xs whitespace-nowrap p-4">
                    {contact.createdAt ? new Date(contact.createdAt).toLocaleDateString() : "N/A"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center p-4">
                  No contacts found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {filteredContacts.length > limit && (
        <div className="flex justify-between items-center px-6 py-4">
          <button
            onClick={handlePrev}
            disabled={page === 1}
            className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded disabled:opacity-50"
          >
            Previous
          </button>
          <span className="text-sm">
            Page {page} of {totalPages}
          </span>
          <button
            onClick={handleNext}
            disabled={page === totalPages}
            className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default GetContact;
